import constants from '@/helpers/constants'

export default (schedule, translations) => {
  const obj = {
    schedule: '',
    currentSchedule: '',
    openedStatus: constants.SHOPS_OPENED_STATUSES.CLOSE,
    opened: false,
    label: {
      translationKey: 'shops_status_closed',
      color: '#909090'
    }
  }
  if (!schedule) {
    return obj
  }

  let startTime = ''
  let endTime = ''
  let currentHours = new Date().getHours()

  schedule.forEach(item => {
    if (item.today) {
      obj['currentSchedule'] = `${item.today.label} ${item.today.time_start ? item.today.time_start + '-' + item.today.time_end : ''}`
      startTime = item.today.time_start.split(':')[0]
      endTime = item.today.time_end.split(':')[0]
    }

    if (item.days) {
      item.days.forEach(el => {
        obj['schedule'] += `${el.days} ${el.time}${el.launch_time ? ', ' + el.launch_time : ''}${el.additional_info ? ', ' + el.additional_info : ''}<br>`
      })
    }
  })

  if (currentHours >= +startTime && currentHours < +endTime && currentHours + 1 !== +endTime) {
    obj['openedStatus'] = constants.SHOPS_OPENED_STATUSES.OPEN
    obj['opened'] = true
    obj['label'] = {
      translationKey: 'shops_status_opened',
      color: '#188D4D'
    }
  } else if (currentHours + 1 === +endTime) {
    obj['openedStatus'] = constants.SHOPS_OPENED_STATUSES.WILL_CLOSE
    obj['opened'] = true
    obj['label'] = {
      translationKey: 'shops_status_will_closed',
      color: '#E6B404'
    }
  }

  return obj
}
